<template>
    <section class="title-data">
	    <p>提示：本页面提供的数据仅供商户作为调整经营策略参考，不作为结款与验证的准确依据。</p>
    </section>
</template>

<style lang="scss" scoped="scoped">
    .title-data {
        > h2 {
            display: inline-block;
            height: 35px;
	        line-height: 35px;
            vertical-align: top;
            font-size: 20px;
            color: #6e808b;
	        margin: 0;
            &:nth-of-type(2) {
                color: #152c3c;
            }
        }
        > span {
            display: inline-block;
            height: 100%;
            vertical-align: top;
            padding: 0 10px;
            color: #ccd2e0;
	        margin-top: 6px;
        }
	    > p {
		    line-height: 35px;
		    background-color: #fffcd6;
			border: 1px solid #f7dc8f;
		    text-indent: 10px;
	    }
    }
</style>

<script>
    export default {
        data () {
            return {}
        },
        props: ['title']
    }
</script>



// WEBPACK FOOTER //
// Title.vue?6a81aa91